// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WPCR","toggle":"styles_toggle__TDGNY","preview":"styles_preview__3BMsy"};